import { render, staticRenderFns } from "./serverMemoryConfig.vue?vue&type=template&id=9f85f864"
import script from "./serverMemoryConfig.vue?vue&type=script&lang=js"
export * from "./serverMemoryConfig.vue?vue&type=script&lang=js"
import style0 from "./serverMemoryConfig.vue?vue&type=style&index=0&id=9f85f864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports